export const PASSWORD_VALIDATIONS = [
  { key: 'minimumChar', label: 'change_password_validation.minimumChar' },
  { key: 'minimumNumber', label: 'change_password_validation.minimumNumber' },
  {
    key: 'minimumCapitalChar',
    label: 'change_password_validation.minimumCapitalChar',
  },
  { key: 'minimumSymbol', label: 'change_password_validation.minimumSymbol' },
];
